<div class="error-page">
  <div class="error-card">
    <i class="fa-light fa-map-signs"></i>
    <h1>404</h1>
    <p>The page you're looking for doesn't exist.</p>
    <a [routerLink]="['/']" target="_self" *ngIf="!iframe" class="btn btn-primary">Go to Home</a>
    <a [routerLink]="['/']" target="_top" *ngIf="iframe" class="btn btn-primary">Go to Home</a>
  </div>
</div>
